const STORAGE_KEY = 'justisio_blog_drawer_dismissed_at';
const COOLDOWN_HOURS = 0;

export const blogDrawerStorage = {
  isCooldownActive: (): boolean => {
    if (typeof window === 'undefined') return false;
    const dismissedAt = localStorage.getItem(STORAGE_KEY);
    if (!dismissedAt) return false;

    const dismissedTime = parseInt(dismissedAt, 10);
    const now = Date.now();
    const hoursSinceDismissal = (now - dismissedTime) / (1000 * 60 * 60);

    return hoursSinceDismissal < COOLDOWN_HOURS;
  },

  setDismissed: (): void => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  },

  clearDismissed: (): void => {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(STORAGE_KEY);
  },
};
